export const initDeploymentDetector = () => {
    if ((window as any).__DEPLOYMENT_DETECTOR_LOADED__) return;
    (window as any).__DEPLOYMENT_DETECTOR_LOADED__ = true;

    const trigger = () => {
        console.warn("🔥 Deployment chunk or MIME error detected");
        window.dispatchEvent(new CustomEvent("deployment-error"));
    };

    // --- 1. Capture <script type="module"> load errors ---
    document.addEventListener(
        "error",
        (event: any) => {
            const target = event?.target;

            if (target?.tagName === "SCRIPT") {
                // Covers: MIME type wrong, file missing, blocked by CSP
                trigger();
            }
        },
        true
    );

    // --- 2. Capture global JS errors ---
    window.addEventListener(
        "error",
        (event: any) => {
            const msg = event?.message || event?.error?.message || "";

            if (
                msg.includes("MIME") ||
                msg.includes("Unexpected token") ||
                msg.includes("HTML") ||
                msg.includes("disallowed MIME type") ||
                msg.includes("error loading dynamically imported module") ||
                msg.includes("NS_ERROR_CORRUPTED_CONTENT")
            ) {
                trigger();
            }
        },
        true
    );

    // --- 3. Capture failed dynamic imports ---
    window.addEventListener("unhandledrejection", (event: any) => {
        const msg = String(event.reason?.message || event.reason || "");

        if (
            msg.includes("MIME") ||
            msg.includes("HTML") ||
            msg.includes("Failed to fetch dynamically imported module") ||
            msg.includes("error loading dynamically imported module")
        ) {
            trigger();
        }
    });
};
